<div [ngClass]="theme.getThemeClass()" class="container-fluid">
  <!-- Nav Filter Search  -->
  <nav id="search-component" class="filter-group">
   <!--  <input
      #searchBox
      type="search"
      id="search-box"
      [(ngModel)]="userFilterTest"
      (input)="search()"
      class="form-control"
      placeholder="{{ 'userlistSearchInputPlaceHolder' | translate }}"
      aria-label="Search"
      aria-describedby="search-addon"
    /> -->
    &nbsp;
    <!-- Filter by Workerorder status -->
    <select
      class="form-control"
      name="work_order_status"
      aria-label="Work Order Status"
      aria-describedby="basic-addon1"
      [(ngModel)]="workOrderService.workOrderData.work_order_status"
      [ngClass]="{ hasValue: workOrderService.workOrderData.work_order_status }"
      (change)="onFilterByStatusChange()"
    >
      <option value="">{{ 'workOrderStatus' | translate }}</option>
      @for (status of WorkOrderStatus; track status.value) {
        <option [value]="status.value">{{ status.label | translate }}</option>
      }
    </select>
    &nbsp;
    <!-- Filter by workerder type -->
    <select
      class="form-control"
      name="work_order_type"
      aria-label="Work Order Type"
      aria-describedby="basic-addon1"
      [(ngModel)]="workOrderService.workOrderData.work_order_type"
      [ngClass]="{ hasValue: workOrderService.workOrderData.work_order_type }"
      (change)="onFilterByTypeChange()"
    >
      <option value="">{{ 'workOrderType' | translate }}</option>
      @for (type of WorkOrderTypes; track type.value) {
        <option [value]="type.value">{{ type.label | translate }}</option>
      }
    </select>
    &nbsp;
    <!-- Filter by client -->

    <select
      class="form-control"
      name="client"
      aria-label="client"
      aria-describedby="basic-addon1"
      [(ngModel)]="workOrderService.workOrderData.client_id"
      [ngClass]="{ hasValue: workOrderService.workOrderData.client_id }"
      (change)="onFilterByClientChange()"
    >
      <option value="">{{ 'clientName' | translate }}</option>
      @for (client of clientArray; track client.client_id) {
        <option [value]="client.client_id">{{ client.client_name }}</option>
      }
    </select>
  </nav>

  <!-- Header for the work order list -->
  <header [ngClass]="theme.getThemeClass()" class="table-header">
    <span class="left"
      >{{ "workOrderList" | translate }}
      <a (click)="refreshList()"><i class="fas fa-sync"></i></a>
    </span>
    <span class="right">
      <button
        [ngClass]="theme.getThemeClass()"
        class="btn btn-dropdown"
        id="buttonDropdown"
        routerLink="/work-order-create"
      >
        {{ "createWorkOrder" | translate }}
      </button>
    </span>
  </header>

  <!-- Section for work order list -->
  <section [ngClass]="theme.getThemeClass()" class="table-container">
    <article class="table-responsive minMarginBotton">
      <table class="table table-hover">
        <thead>
          <tr>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              {{ "workOrderTypeth" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              {{ "workOrderStatusth" | translate }}
            </th>
            <th
              [ngClass]="theme.getThemeClass()"
              class="hide-small-screen"
              scope="col"
            >
              {{ "workOrderDatetime" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              {{ "workOrderDeadline" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              {{ "_client" | translate }}
            </th>
            <th
              [ngClass]="theme.getThemeClass()"
              class="hide-small-screen"
              scope="col"
            >
              {{ "createdBy" | translate }}
            </th>
          </tr>
        </thead>
        @for (order of workOrderListArray; track order.work_order_id) {
          <tbody>
            <tr class="verticalAlign">
              <!-- Order Type -->
              <td [ngClass]="theme.getThemeClass()">
                {{ orderTypeLabelKeyMap[order.work_order_type] | translate }}
              </td>
              <!-- Status -->
              <td [ngClass]="theme.getThemeClass()">
                <a [routerLink]="" href="javascript:void(0)">
                  {{ orderStatusLabelKeyMap[order.status] | translate }}
                </a>
              </td>
              <!-- Datetime -->
              <td class="hide-small-screen" [ngClass]="theme.getThemeClass()">
                <a [routerLink]="" href="javascript:void(0)">
                  {{ formatTimestamp(order.work_order_datetime) }}
                </a>
              </td>
              <!-- Deadline -->
              <td [ngClass]="theme.getThemeClass()">
                <a [routerLink]="" href="javascript:void(0)">
                  {{ formatTimestamp(order.work_order_deadline) }}
                </a>
              </td>
              <!-- Client -->
              <td [ngClass]="theme.getThemeClass()">
                <a [routerLink]="" href="javascript:void(0)">
                  @if (getClientNameById(order.client_id)) {
                    {{ getClientNameById(order.client_id) }}
                  } @else {
                    {{ "_clientNotFound" | translate }}
                  }
                </a>
              </td>
              <!-- Created By -->
              <td class="hide-small-screen" [ngClass]="theme.getThemeClass()">
                <a [routerLink]="" href="javascript:void(0)">
                  @if (getUserNameBySub(order.created_by)) {
                    {{ getUserNameBySub(order.created_by) }}
                  } @else {
                    {{ "_userNotFound" | translate }}
                  }
                </a>
              </td>
            </tr>
          </tbody>
        }
      </table>
    </article>
  </section>
</div>

<app-system-message></app-system-message>
